import { Alert, Button, LinearProgress } from '@mui/material';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import PublishIcon from '@mui/icons-material/Publish';
import { FormDrawer } from '../../../../components/form-drawer';
import { IStatusSubmissionPublicationResponse } from '../../../../model/sep/submission-publications/response/status-submission-publication-response';
import { useSubmissionPublicationDetailController } from '../context/submission-publication-detail-controller';
import { SUBMISSION_STATUS_NEW } from './submission-publication-status';
import { SubmissionFilesSection, SubmissionInfoSection, SubmissionReviewSection, SubmissionVehiclesSection } from './submission-publication-detail-sections';

export interface ISubmissionPublicationDetailProps {
    submissionId?: number;
    status: IStatusSubmissionPublicationResponse[];
    onClose: () => void;
    onSaved: () => void;
}

export default function SubmissionPublicationDetail({ submissionId, status, onClose, onSaved }: ISubmissionPublicationDetailProps) {
    const ctrl = useSubmissionPublicationDetailController(submissionId, onSaved, onClose);
    const { detail } = ctrl;

    return (
        <FormDrawer
            open={submissionId !== undefined}
            icon={<ForwardToInboxIcon />}
            title={`Remessa nº ${submissionId ?? ''}`}
            subtitle={detail?.title}
            saveLabel="Salvar"
            isSaving={ctrl.isSaving}
            saveDisabled={ctrl.loading || !detail}
            onClose={onClose}
            onSave={ctrl.handleSave}
        >
            {ctrl.loading && <LinearProgress />}
            {detail?.statusId === SUBMISSION_STATUS_NEW && (
                <Alert
                    severity="info"
                    action={<Button color="inherit" size="small" startIcon={<PublishIcon />} onClick={ctrl.handlePublish}>Publicar</Button>}
                >
                    Remessa nova, pronta para ser publicada no Diário Oficial.
                </Alert>
            )}
            <SubmissionInfoSection detail={detail} />
            <SubmissionFilesSection files={ctrl.files} onDownload={ctrl.handleDownloadFile} onDownloadAll={ctrl.handleDownloadAll} />
            <SubmissionVehiclesSection vehicles={detail?.publishingVehicles} />
            <SubmissionReviewSection form={ctrl.form} status={status} statusError={ctrl.statusError} onChange={ctrl.handleFormChange} />
        </FormDrawer>
    );
}
